import React from 'react';
import styled from 'styled-components';

const StyledFooterPanel = styled.div`
  position: absolute;
  display: flex;
  bottom: 0;
  left: 50%;
  width: 748px;
  height: 420px;
  background: #FFBC0D;
  justify-content: center;
  border-radius: 50%;
  transform: translate3d(-50%, 50%, 0);

  > * {
    transform: translateY(-50%);
  }
`;

const FooterPanel = ({ children }) => {
  return (
    <StyledFooterPanel>
      {children}
    </StyledFooterPanel>
  );
}

export default FooterPanel;